<template>
  <div
    class="stakeholder"
    :class="{ multiple: list.length > 1 }"
    v-if="list.length"
  >
    <div v-if="list.length > 1">{{ list.length }}</div>
    <div v-if="list.length === 1">{{ list[0].initials }}</div>
  </div>
</template>

<script>
export default {
  name: 'Stakeholder',
  props: {
    list: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.stakeholder {
  min-width: 38px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: white;
  background-color: #222222;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid white;
  top: 0;
  transform: translateZ(0);
  will-change: transform;
  transition: transform 300ms linear;

  > div {
    color: white;
  }

  &:hover {
    transform: translateY(-3px);
  }

  + .stakeholder {
    margin-left: -6px;
  }

  &.multiple {
    background-color: white;
    border: 2px solid #26292f;
    > div {
      color: #26292f;
    }
  }
}
</style>
